import { IScore } from "../../../common/types";
import { scoreStaffDistance } from "./score-display/parameters";

export const getNewScore = (taskType?: string): IScore => {
    return {
        barlines: [],
        signatures: [
            {
                bar: 1,
                num: 4,
                den: 4,
            },
        ],
        bars: [
            null,
            {
                notes: [],
            },
        ],
        doPos: {
            i: 0,
            o: 4,
        },
        settings: {
            staffDistance: scoreStaffDistance,
            staffLines: taskType === "rhytName" ? false : true,
            stick: false,
            e16: true,
            upperText: taskType === "barSorting2" ? 0 : 1,
            systemDistance: scoreStaffDistance * 0.2,
        },
    };
};
